import React, { useEffect, useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import constantData from "../constants/constantData.json";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import loaderIcon from '../assets/images/icons/loader.gif';
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import pptIcon from '../assets/images/icons/ppt.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import backButton from '../assets/images/back_button_arrow.svg';
import publishersIcon from '../assets/images/icons/publishers.svg';
import { Radio, Select, Col, Row, Space, Input, Checkbox, Modal, Switch } from 'antd';
import { default as ReactSelect } from 'react-select';


const PublisherImport = ({ handlePageViewChange }) => {

    const buttonRef4 = useRef(null);

    useEffect(() => {
        const handleEnterKeyPress4 = (event) => {
            if (event.key === "Enter" && buttonRef4 && buttonRef4?.current && searchDisable === false) {
                buttonRef4?.current.click();
            }
        };
        document.addEventListener("keydown", handleEnterKeyPress4);
        return () => {
            document.removeEventListener("keydown", handleEnterKeyPress4);
        };
    }, []);


    const [formVisible, setFormVisible] = useState(false);
    const [publisherId, setPublisherId] = useState("");
    const [publisherIdError, setPublisherIdError] = useState(false);
    const [publisherIdErrorMsg, setPublisherIdErrorMsg] = useState("");
    const [searchLoader, setSearchLoader] = useState(false);
    const [extraData, setExtraData] = useState({
        p_adkId: "",
        status: "",
        reg_date: "",
        web_desc: "",
        s_passthrough: ""
    });

    const [oldData, setOldData] = useState({
        p_name: "",
        o_name: "",
        email: "",
        c_website: "",
        im: { "label": "", "value": "" },
        address: "",
        state: "",
        city: "",
        pincode: "",
        country: "",
        o_contact: "",
        phone: { "code": "", "p_number": "" },
        s_type: "",
        s_name: "",
        s_domain: "",
        extraData: "",
    })


    function resetImportPublisherView() {
        setPublisherId("")
        setSearchDisable(false)
        setFormVisible(false)
        setPublisherIdError(false)
        setPublisherIdErrorMsg("")
        setSearchLoader(false)

    }

    function resetImportPublisher() {

        setOldData({
            p_name: "",
            o_name: "",
            email: "",
            c_website: "",
            im: { "label": "", "value": "" },
            address: "",
            state: "",
            city: "",
            pincode: "",
            country: "",
            o_contact: "",
            phone: { "code": "", "p_number": "" },
            s_type: "",
            s_name: "",
            s_domain: "",
            extraData: "",
        })

        setExtraData({
            p_adkId: "",
            status: "",
            reg_date: "",
            web_desc: "",
            s_passthrough: ""
        })

        setName("");
        setNameIsRequiredError(false);

        setCompanyName("");
        setCompanyNameIsRequiredError(false);

        setEmailIsRequiredError(false);
        setEmailUrlError(false);

        setCompanyWebsite("");
        setCompanyWebsiteIsRequiredError(false);
        setCompanyWebsiteUrlError(false);

        setIm("");
        setImIsRequiredError(false);
        setSelectedIm("skype");

        setAddress("");
        setState("");
        setCity("");
        setPincode("");
        // setCountryOptions([]);
        setCountry("");
        setCountryIsRequiredError(false);



        // setDialCodeOptions([]);
        setDialCode({ label: "+91", value: "+91" });
        setPhone("");
        setPhoneIsRequiredError(false);

        setCompanyLinkedin("");
        setCompanyLinkedinUrlError(false);

        setSellerType("");
        setSellerTypeIsRequiredError(false)

        setSellerName("");
        setSellerNameIsRequiredError(false);

        setSellerDomain("");
        setSellerDomainIsRequiredError(false);
        setSellerDomainUrlError(false);

        setMediakit([]);

        setButtonValue(false);
    }


    const [searchDisable, setSearchDisable] = useState(false)

    function onChangePublisherId(event) {
        setSearchDisable(false)
        setPublisherIdError(false);
        if (/^\d*$/.test(event.target.value.trim())) {
            setPublisherId(event.target.value.trim());
        }
    }

    function onBlurPublisherId(event) {
        // if (event.target.value.trim().length === 0) {
        //     setPublisherIdError(true);
        // }
        setPublisherId(event.target.value.trim());
    }


    function handleSearchPublisher() {

        if (publisherId.trim().length === 0) {
            setPublisherIdErrorMsg("This field is required");
            setPublisherIdError(true);
        }
        else {
            resetImportPublisher()
            setSearchLoader(true)
            axios
                .get(configData.SERVER_URL + "port/getPubData?publisherId=" + publisherId, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setSearchDisable(true)

                    let tempExtraData = { ...extraData }
                    tempExtraData.p_adkId = response.data.data.p_adkId
                    tempExtraData.status = response.data.data.status
                    tempExtraData.reg_date = response.data.data.reg_date
                    tempExtraData.web_desc = response.data.data.web_desc
                    tempExtraData.s_passthrough = response.data.data.s_passthrough

                    setExtraData(tempExtraData)


                    //old data set
                    let tempOldData = { ...oldData }


                    tempOldData.extraData = tempExtraData

                    setName(response.data.data.p_name)
                    tempOldData.p_name = response.data.data.p_name

                    if (response.data.data.o_name.trim().length !== 0) {
                        setCompanyName(response.data.data.o_name)
                        tempOldData.o_name = response.data.data.o_name
                    }

                    setEmail(response.data.data.email)
                    tempOldData.email = response.data.data.email


                    if (response.data.data.c_website.trim().length !== 0) {
                        setCompanyWebsite(response.data.data.c_website)
                        tempOldData.c_website = response.data.data.c_website
                    }

                    if (response.data.data.address.trim().length !== 0) {
                        setAddress(response.data.data.address)
                        tempOldData.address = response.data.data.address
                    }

                    if (response.data.data.state.trim().length !== 0) {
                        setState(response.data.data.state)
                        tempOldData.state = response.data.data.state
                    }


                    if (response.data.data.city.trim().length !== 0) {
                        setCity(response.data.data.city)
                        tempOldData.city = response.data.data.city
                    }

                    if (response.data.data.pincode.trim().length !== 0) {
                        setPincode(response.data.data.pincode)
                        tempOldData.pincode = response.data.data.pincode
                    }

                    if (response.data.data.country.trim().length !== 0) {
                        setCountry(response.data.data.country)
                        tempOldData.country = response.data.data.country
                    }

                    if (response.data.data.phone.trim().length !== 0) {
                        // setPhone(response.data.data.phone)
                        tempOldData.phone.p_number = response.data.data.phone
                    }

                    if (response.data.data.o_contact.trim().length !== 0) {
                        setCompanyLinkedin(response.data.data.o_contact)
                        tempOldData.o_contact = response.data.data.o_contact
                    }

                    if (response.data.data.s_type.trim().length !== 0) {
                        setSellerType(response.data.data.s_type)
                        tempOldData.s_type = response.data.data.s_type
                    }

                    if (response.data.data.s_name.trim().length !== 0) {
                        setSellerName(response.data.data.s_name)
                        tempOldData.s_name = response.data.data.s_name
                    }

                    if (response.data.data.s_domain.trim().length !== 0) {
                        setSellerDomain(response.data.data.s_domain)
                        tempOldData.s_domain = response.data.data.s_domain
                    }

                    setOldData(tempOldData)

                    setFormVisible(true)
                    setSearchLoader(false)

                })
                .catch((error) => {
                    setPublisherIdErrorMsg("Publisher ID does not exist")
                    setPublisherIdError(true)

                    setFormVisible(false)
                    setSearchLoader(false)
                });

        }

    }


    ///////////////////////////////////////////onboarding related code starts  /////////////////////////////////////////////////////////////////////////////
    React.useEffect(() => {
        resetImportPublisherView()
        resetImportPublisher()

        axios
            .get(configData.SERVER_URL + "user/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryOptions(response.data.data);
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "user/dialCodeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDialCodeOptions(response.data.data);
            })
            .catch((error) => { });
    }, [])


    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{label}</span><b>{value}</b>
            {/* <b>{label}</b> */}
        </div>
    );
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-5-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);


    const [email, setEmail] = useState("");
    const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
    const [emailUrlError, setEmailUrlError] = useState(false);

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("skype");

    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");

    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");
    const [countryIsRequiredError, setCountryIsRequiredError] = useState(false);

    const [dialCodeOptions, setDialCodeOptions] = useState([]);
    const [dialCode, setDialCode] = useState({ label: "+91", value: "+91" });
    const [phone, setPhone] = useState("");
    const [phoneIsRequiredError, setPhoneIsRequiredError] = useState(false);

    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

    const [sellerType, setSellerType] = useState("");
    const [sellerTypeIsRequiredError, setSellerTypeIsRequiredError] = useState(false);

    const [sellerName, setSellerName] = useState("");
    const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
        useState(false);

    const [sellerDomain, setSellerDomain] = useState("");
    const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
        useState(false);
    const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);

    // const [isGamChecked, setIsGamChecked] = useState(true);

    const [mediakit, setMediakit] = useState([]);

    const [buttonValue, setButtonValue] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateLinkedinUrl = (linkedinUrl) => {
        return String(linkedinUrl)
            .toLowerCase()
            .match(/^(https?:\/\/)?([^\/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    // function onChangeEmail(event) {
    //     setEmailIsRequiredError(false);
    //     setEmail(event.target.value);

    //     if (validateEmail(event.target.value) === null) {
    //         setEmailUrlError(true);
    //     } else {
    //         setEmailUrlError(false);
    //     }
    // }

    // function onBlurEmail(event) {
    //     if (event.target.value.trim().length === 0) {
    //         setEmailUrlError(false);
    //         setEmailIsRequiredError(true);
    //     } else {
    //         if (validateEmail(event.target.value.trim()) === null) {
    //             setEmailUrlError(true);
    //         } else {
    //             setEmailUrlError(false);
    //         }
    //     }
    //     setEmail(event.target.value.trim());
    // }

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim());
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }

    function onChangeAddress(event) {
        setAddress(event.target.value);
    }

    function onBlurAddress(event) {
        setAddress(event.target.value.trim());
    }

    function onChangeState(event) {
        setState(event.target.value);
    }

    function onBlurState(event) {
        setState(event.target.value.trim());
    }

    function onChangeCity(event) {
        setCity(event.target.value);
    }

    function onBlurCity(event) {
        setCity(event.target.value.trim());
    }

    function onChangePincode(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setPincode(event.target.value.trim());
        }
    }

    function onBlurPincode(event) {
        setPincode(event.target.value.trim())
    }

    function onChangePhone(event) {
        setPhoneIsRequiredError(false);
        if (/^\d*$/.test(event.target.value.trim())) {
            setPhone(event.target.value.trim());
        }
    }

    function onBlurPhone(event) {
        if (event.target.value.trim().length === 0) {
            setPhoneIsRequiredError(true);
        }
        setPhone(event.target.value.trim());
    }


    function onChangeCompanyLinkedin(event) {
        setCompanyLinkedin(event.target.value);
        if (event.target.value.length === 0) {
            setCompanyLinkedinUrlError(false);
        } else {
            if (validateLinkedinUrl(event.target.value) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
    }

    function onBlurCompanyLinkedin(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyLinkedinUrlError(false);
        }
        else {
            if (validateLinkedinUrl(event.target.value.trim()) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
        setCompanyLinkedin(event.target.value.trim());
    }

    function onChangeSellerType(event) {
        setSellerTypeIsRequiredError(false)
        setSellerType(event.target.value);
    }

    function onChangeSellerName(event) {
        setSellerNameIsRequiredError(false);
        setSellerName(event.target.value);
    }

    function onBlurSellerName(event) {
        if (event.target.value.trim().length === 0) {
            setSellerNameIsRequiredError(true);
        }
        setSellerName(event.target.value.trim());
    }

    function onChangeSellerDomain(event) {
        setSellerDomain(event.target.value);

        if (event.target.value.length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            setSellerDomainIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
    }

    function onBlurSellerDomain(event) {
        if (event.target.value.trim().length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
        setSellerDomain(event.target.value.trim());
    }

    const [dragging, setDragging] = useState(false);

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);

        let count = 0;

        const droppedFiles = Array.from(e.dataTransfer.files);
        if (droppedFiles.length > 0) {
            let tempMediaKit = [...mediakit];
            for (let file of droppedFiles) {

                if (file.size / (1024 * 1024) < 100 && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
                    tempMediaKit.push({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                }
                else {
                    count++;

                }
            }
            setMediakit(tempMediaKit);
            const fileInput00 = document.getElementById("file000");
            fileInput00.value = "";
            if (count !== 0) {
                notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && ppt/pptx format`)
            }
        }
    };

    function onChangeMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            let tempMediaKit = [...mediakit];

            for (let file of e.target.files) {

                if (file.size / (1024 * 1024) < 100 && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
                    tempMediaKit.push({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                }
                else {
                    count++;

                }
            }
            setMediakit(tempMediaKit);
            const fileInput00 = document.getElementById("file000");
            fileInput00.value = "";

            if (count !== 0) {
                notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && ppt/pptx format`)
            }

        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            name !== "" &&
            companyName !== "" &&
            email !== "" &&
            companyWebsite !== "" &&
            im !== "" &&
            country !== "" &&
            phone !== "" &&
            sellerType !== "" &&
            sellerName !== "" &&
            sellerDomain !== ""

        ) {
            if (
                nameIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                emailIsRequiredError === false &&
                emailUrlError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                imIsRequiredError === false &&
                countryIsRequiredError === false &&
                phoneIsRequiredError === false &&
                companyLinkedinUrlError === false &&
                sellerTypeIsRequiredError === false &&
                sellerNameIsRequiredError === false &&
                sellerDomainIsRequiredError === false &&
                sellerDomainUrlError === false

            ) {


                let formData = new FormData();

                formData.append("oldData", JSON.stringify(oldData))
                formData.append("p_name", name);
                formData.append("o_name", companyName);
                formData.append("email", email);
                formData.append("c_website", companyWebsite);
                formData.append("im", JSON.stringify({ "label": selectedIm, "value": im }));
                formData.append("address", address);
                formData.append("state", state);
                formData.append("city", city);
                formData.append("pincode", pincode);
                formData.append("country", country);
                formData.append("o_contact", companyLinkedin);
                formData.append("phone", JSON.stringify({ "code": dialCode.value, "p_number": phone }));
                formData.append("s_type", sellerType);
                formData.append("s_name", sellerName);
                formData.append("s_domain", sellerDomain);
                formData.append("extraData", JSON.stringify(extraData))
                mediakit.forEach((file) => {
                    formData.append('mediaKit', file.data);
                });




                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");
                    // let id = jwtDecode(token)._id;

                    axios
                        .post(configData.SERVER_URL + `port/portPubData`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                window.location.reload()
                            }, 2000)
                            // setStep(2)
                            // setTimeout(() => {
                            //   window.location.replace("/login");
                            // }, 1500);
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });
                }
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (email === "") {
                setEmailIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
            if (country === "") {
                setCountryIsRequiredError(true);
            }
            if (phone === "") {
                setPhoneIsRequiredError(true);
            }
            if (sellerType === "") {
                setSellerTypeIsRequiredError(true);
            }
            if (sellerName === "") {
                setSellerNameIsRequiredError(true);
            }
            if (sellerDomain === "") {
                setSellerDomainIsRequiredError(true);
            }
        }
    };

    ///////////////////////////////////////////onboarding related code ends /////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className='container_box--breadcrumb-list'>
                        <li><Link onClick={() => {
                            handlePageViewChange("table")
                            resetImportPublisher()
                            resetImportPublisherView()

                        }} ><img src={publishersIcon} alt='USP' /> Publishers</Link></li>
                        <li className='primary'>Import</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetImportPublisher()
                                resetImportPublisherView()

                            }}
                        />
                        <h1 className="heading">
                            Import Publisher
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Publisher ID</label>
                                    <p className='sub_text'>Enter Publisher ID</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={20} className="pe-0">
                                            <div className="form_content_block--group mb_0">
                                                <label className='form_label'>Publisher ID * </label>
                                                <Input
                                                    className='form_control basic'

                                                    placeholder='eg.206831'
                                                    value={publisherId} onChange={onChangePublisherId} onBlur={onBlurPublisherId}
                                                />
                                                {/* <span className='error_content'>
                                                    <></>
                                                </span> */}

                                            </div>

                                        </Col>


                                        {searchLoader ?
                                            <Col span={4} className='align-items-end d-flex'>

                                                <button className='btn_primary btn loader'
                                                    onClick={handleSearchPublisher}
                                                > <img
                                                        src={loaderIcon}
                                                        alt="USP"
                                                        className="loader_icon"
                                                    /></button>
                                            </Col>
                                            :

                                            <Col span={4} className='align-items-end d-flex'>
                                                <button className='btn btn_primary'
                                                    ref={buttonRef4}
                                                    disabled={searchDisable}
                                                    onClick={handleSearchPublisher}
                                                ><span>Search</span></button>
                                            </Col>
                                        }
                                        <Col span={20} className="d_flex justify-content-end">
                                            <span className="error_content">
                                                {
                                                    publisherIdError &&
                                                    <>{publisherIdErrorMsg}</>

                                                }
                                            </span></Col>
                                        <Col span={4}><span className="error_content"></span></Col>
                                    </Row>

                                </div>
                            </Col>
                        </Row>
                        {formVisible &&
                            <>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Basic details</label>
                                            <p className='sub_text'>General information overview</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Name *</label>
                                                        <Input
                                                            className={
                                                                nameIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={name}
                                                            onBlur={onBlurName}
                                                            onChange={onChangeName}
                                                            autocomplete="off"
                                                        />
                                                        <span className='error_content'>
                                                            {nameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Organisation Name *</label>
                                                        <Input
                                                            className={
                                                                companyNameIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={companyName}
                                                            onBlur={onBlurCompanyName}
                                                            onChange={onChangeCompanyName}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {companyNameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Email Address *</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={email}
                                                            disabled
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Company website *</label>
                                                        <Input
                                                            className={
                                                                (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={companyWebsite}
                                                            onBlur={onBlurCompanyWebsite}
                                                            onChange={onChangeCompanyWebsite}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {companyWebsiteIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                            {companyWebsiteUrlError && (
                                                                <> Invalid Website Url</>
                                                            )}

                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>IM  *</label>
                                                        <Space.Compact className='form_compact basic'>
                                                            <Select
                                                                value={selectedIm}
                                                                onChange={onChangeSelectedIm}
                                                                options={constantData.IM_OPTIONS}
                                                                className='form_select'
                                                            />
                                                            <Input
                                                                className={imIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                                }
                                                                value={im}
                                                                onChange={onChangeIm}
                                                                onBlur={onBlurIm}
                                                                autocomplete="off"
                                                            />
                                                        </Space.Compact>
                                                        <span className="error_content">
                                                            {imIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Address</label>
                                            <p className='sub_text'>Location and mailing address</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Address Line 1</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={address}
                                                            onBlur={onBlurAddress}
                                                            onChange={onChangeAddress}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>City </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={city}
                                                            onBlur={onBlurCity}
                                                            onChange={onChangeCity}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>State</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={state}
                                                            onBlur={onBlurState}
                                                            onChange={onChangeState}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Postal/ Zip Code  </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={pincode}
                                                            onBlur={onBlurPincode}
                                                            onChange={onChangePincode}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                        <label className='form_label'>Country  *</label>
                                                        <Select
                                                            showSearch
                                                            // open={true}
                                                            optionFilterProp="label"
                                                            className={countryIsRequiredError
                                                                ? "form_select basic error"
                                                                : "form_select basic"
                                                            }
                                                            value={country}
                                                            onChange={(event) => {
                                                                setCountryIsRequiredError(false)
                                                                setCountry(event);
                                                            }}
                                                            options={countryOptions}
                                                        // onSearch={(value) => {
                                                        //     console.log('search:', value);
                                                        //   }}
                                                        />
                                                        <span className="error_content">
                                                            {countryIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Contact details</label>
                                            <p className='sub_text'>Phone and other conact information</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Phone Number  *</label>
                                                        <div className='input_group'>
                                                            <ReactSelect
                                                                value={dialCode}
                                                                onChange={(event) => {
                                                                    setDialCode(event);
                                                                }}
                                                                options={dialCodeOptions}
                                                                isSearchable={true}
                                                                // menuIsOpen={true}
                                                                className="form_select--w-20"
                                                                classNamePrefix="form_select basic"
                                                                formatOptionLabel={formatOptionLabel}
                                                                styles={customStyles}
                                                                placeholder=""
                                                            />
                                                            <Input
                                                                className={phoneIsRequiredError
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                                }
                                                                value={phone}
                                                                onBlur={onBlurPhone}
                                                                onChange={onChangePhone}
                                                                autocomplete="off"
                                                            />
                                                        </div>
                                                        {/* } */}
                                                        <span className="error_content">
                                                            {phoneIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Linkedin URL </label>
                                                        <Input
                                                            className={companyLinkedinUrlError
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            placeholder='https://'
                                                            value={companyLinkedin}
                                                            onBlur={onBlurCompanyLinkedin}
                                                            onChange={onChangeCompanyLinkedin}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {companyLinkedinUrlError && (
                                                                <> Invalid LinkedIn Url</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Seller details</label>
                                            <p className='sub_text'>Seller's business specifics</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label d_flex'>Seller Type *</label>
                                                        <Radio.Group onChange={onChangeSellerType} value={sellerType}
                                                            className="form_radio equal_space">
                                                            <Radio className='radio_btn' value="Publisher">Publisher</Radio>
                                                            <Radio className='radio_btn' value="Intermediary">Intermediary</Radio>
                                                            <Radio className='radio_btn' value="Both">Both</Radio>
                                                        </Radio.Group>
                                                        <span className="error_content">
                                                            {sellerTypeIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Seller Name *</label>
                                                        <Input
                                                            className={sellerNameIsRequiredError
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerName}
                                                            onBlur={onBlurSellerName}
                                                            onChange={onChangeSellerName}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {sellerNameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Seller Domain *</label>
                                                        <Input
                                                            className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerDomain}
                                                            onBlur={onBlurSellerDomain}
                                                            onChange={onChangeSellerDomain}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {sellerDomainIsRequiredError && (
                                                                <> This field is required</>
                                                            )}

                                                            {sellerDomainUrlError && (
                                                                <> Invalid Domain</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                {/* <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>GAM Integration</label>
                                    <p className='sub_text'>Google Ad Manager setup</p>
                                </div>
                            </Col>

                            <Col span={8}>
                                <div className="container_box--form-container">

                                    <div className="form_content_block--group mb_0 d_flex align_items_center justify_content_between">
                                        <label className='form_label form_label_switch'><img src={googleIcon} alt='USP' /> Google Ads Manager</label>
                                        <Switch defaultChecked onChange={onChangeSwitch} />
                                    </div>
                                </div>
                            </Col>
                        </Row> */}
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Media Kit</label>
                                            <p className='sub_text'>Upload ppt</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group">
                                                    <label for='file000'
                                                        className={dragging ? 'ant_upload_drag drag_css_color mb-4' : 'ant_upload_drag mb-4'}

                                                        onDragEnter={handleDragEnter}
                                                        onDragOver={handleDragOver}
                                                        onDragLeave={handleDragLeave}
                                                        onDrop={handleDrop}
                                                    >
                                                        <p className="upload_drag_icon">
                                                            <img src={uploadIcon} alt='USP' />
                                                        </p>
                                                        <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                        <p className="ant_upload_hint">
                                                            PPT (max. 100 MB)
                                                        </p>
                                                    </label>
                                                    <input className='form_upload d-none' type="file"
                                                        name="file000"
                                                        id="file000"
                                                        accept=".ppt, .pptx"
                                                        multiple
                                                        onChange={onChangeMediakit}


                                                    />

                                                    {mediakit.map((media, index) => (

                                                        <div class="ant_upload_list--item">
                                                            <div class="ant_upload_list--content">
                                                                <img src={pptIcon} alt="USP" />
                                                                <div class="ant_upload_list--info">
                                                                    <span class="ant_upload_list--info-name">{media.filename}</span>
                                                                    <span class="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                </div>
                                                            </div>
                                                            <button type="link" class="download_icon download_icon_d2"
                                                                onClick={() => {
                                                                    let tempMediaKit = [...mediakit];
                                                                    tempMediaKit.splice(index, 1);
                                                                    setMediakit(tempMediaKit);
                                                                }}
                                                            >
                                                                <img src={deleteIcon} alt="USP" />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>
                    <div className="hr_custom mb_20"></div>
                    {buttonValue ?
                        <div className="btn_group justify-content-end gap_8 pb_50">
                            <button className='w_120_d2 btn btn_white_outline w_fit_content'
                                disabled
                            >Discard</button>

                            <button
                                className="w_120_d2 btn btn_primary w_fit_content loader"

                            >
                                <span>Submit</span>

                                <img
                                    src={loaderIcon}
                                    alt="USP"
                                    className="loader_icon"
                                />
                            </button>
                        </div> :
                        <div className="btn_group justify-content-end gap_8 pb_50">
                            <button className='w_120_d2 btn btn_white_outline w_fit_content'
                                onClick={() => {
                                    handlePageViewChange("table")
                                    resetImportPublisher()
                                    resetImportPublisherView()

                                }}
                            >Discard</button>
                            <button className='w_120_d2 btn btn_primary w_fit_content'
                                onClick={
                                    handleSubmit
                                }
                                disabled={!formVisible}
                            >Submit</button>
                        </div>
                    }

                </div>
            </div >
        </>

    )

}

export default PublisherImport;